import React from 'react';
import Icon from '../../../components/AppIcon';

const DataSourcePanel = ({ dataSources, selectedSources, onToggleSource }) => {
  const isSelected = (sourceId) => selectedSources?.some((s) => s?.id === sourceId);

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h2 className="text-xl font-semibold text-foreground mb-4">Data Sources</h2>
      <div className="space-y-2">
        {dataSources?.map((source) => {
          const selected = isSelected(source?.id);
          return (
            <div
              key={source?.id}
              onClick={() => onToggleSource?.(source)}
              className={`p-3 border rounded-lg cursor-pointer transition-all ${
                selected
                  ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50'
              }`}
            >
              <div className="flex items-start gap-3">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                  selected ? 'bg-primary/20' : 'bg-muted'
                }`}>
                  <Icon name={source?.icon} size={20} color={selected ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} />
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="text-sm font-semibold text-foreground">{source?.name}</h3>
                    {selected && (
                      <Icon name="CheckCircle" size={16} color="var(--color-primary)" />
                    )}
                  </div>
                  <p className="text-xs text-muted-foreground mb-2">{source?.description}</p>
                  <div className="flex flex-wrap gap-1">
                    {source?.fields?.slice(0, 3)?.map((field) => (
                      <span
                        key={field}
                        className="px-2 py-0.5 bg-muted rounded text-xs text-foreground"
                      >
                        {field}
                      </span>
                    ))}
                    {source?.fields?.length > 3 && (
                      <span className="px-2 py-0.5 bg-muted rounded text-xs text-muted-foreground">
                        +{source?.fields?.length - 3} more
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DataSourcePanel;